// extracted by mini-css-extract-plugin
export var notificationHost = "_cp-0";